import Swiper from 'swiper';

function initCarousel() {
    const elem = document.querySelector('.team-swiper');

 
    if (elem) {
        if (window.innerWidth < 479) {
            console.log('Team slideshow initialised');

            const teamSwiper = new Swiper(elem, {
                  speed: 400,
                  loop: true,
                  slidesPerView: 1,
                  centeredSlides: false,
                  initialSlide: 0
            });
        }
    }
}

initCarousel();
